import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes } from 'react-router-dom';
import { ShepherdTour } from 'react-shepherd';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import { AccessControl } from '../../../components';
import { default as PermissionContextProvider } from '../../../context/PermissionContext/PermissionContext';
import { useAtsAccess, AtsAccess } from '../../../hooks/useAtsAccess';
import ErrorLogger from '../../../providers/ErrorLogger';
import RouteGuard from '../../../routes/RouteGuard';
import { tourOptions, pipelineSteps } from '../../../utils/TourStepsAndOptions';
import { Loader } from '../../conversationWidget/components/Loader';
import MappingListing from '../mappings';
import TalentPoolListing from '../talentpool';

export const CandidatesRoutes = () => {
  const isViewTalentpool = useAtsAccess(AtsAccess.TALENT_POOL);
  const isViewPipeline = useAtsAccess(AtsAccess.PIPELINE);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteWithTitle title="Search Candidate-Talent Pool">
            <RouteGuard>
              <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
                <PermissionContextProvider>
                  {isViewTalentpool == undefined ? (
                    <Loader />
                  ) : isViewTalentpool ? (
                    <TalentPoolListing />
                  ) : (
                    <AccessControl />
                  )}
                </PermissionContextProvider>
              </ErrorBoundary>
            </RouteGuard>
          </RouteWithTitle>
        }
      />
      <Route
        path="/:jobId"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              {isViewTalentpool == undefined ? (
                <Loader />
              ) : isViewTalentpool ? (
                <TalentPoolListing />
              ) : (
                <AccessControl />
              )}
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path="mappings"
        element={
          <RouteWithTitle title="Search Candidate-Pipeline">
            <RouteGuard>
              <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
                <ShepherdTour steps={pipelineSteps} tourOptions={tourOptions}>
                  {isViewPipeline == undefined ? (
                    <Loader />
                  ) : isViewPipeline ? (
                    <MappingListing />
                  ) : (
                    <AccessControl />
                  )}
                </ShepherdTour>
              </ErrorBoundary>
            </RouteGuard>
          </RouteWithTitle>
        }
      />
      <Route
        path="mappings/:source/:encoded"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <ShepherdTour steps={pipelineSteps} tourOptions={tourOptions}>
                {isViewPipeline == undefined ? (
                  <Loader />
                ) : isViewPipeline ? (
                  <MappingListing />
                ) : (
                  <AccessControl />
                )}
              </ShepherdTour>
            </ErrorBoundary>
          </RouteGuard>
        }
      />
    </Routes>
  );
};
